import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  createClientGoalForBonusSuccess: ['response'],
  updateClientGoalForBonusSuccess: ['response'],

  getMTDYTDClientUncategorizedRequest: ['clientId', 'timezoneOffset'],
  getMTDYTDClientUncategorizedSuccess: ['response'],
  getMTDYTDClientUncategorizedFailure: null,

  getYTDClientStatsRequest: ['clientId', 'timezoneOffset'],
  getYTDClientStatsSuccess: ['response'],
  getYTDClientStatsFailure: null,

  getMTDPastYearsClientStatsRequest: ['clientId', 'timezoneOffset', 'currentDay'],
  getMTDPastYearsClientStatsSuccess: ['response'],
  getMTDPastYearsClientStatsFailure: null,

  getDailyEmployeesShiftRequest: ['date', 'timezoneOffset'],
  getDailyEmployeesShiftSuccess: ['response'],
  getDailyEmployeesShiftFailure: null,

  getWeeklyEmployeesShiftRequest: ['startDate', 'endDate', 'timezoneOffset'],
  getWeeklyEmployeesShiftSuccess: ['response'],
  getWeeklyEmployeesShiftFailure: null,

  // Clear all caches
  clearReportsRequest: null,
});

export const ReportsTypes = Types;
export default Creators;
